// =====================================
//
//   通知 相關功能 Service
//   Author: Gray
//   createtime: 2016 / 03 / 10
//   updatetime: 2016 / 03 / 10
//
// =====================================
window.InifECShared.factory("MessageService", ['$q', '$http', '$localStorage', function($q, $http, $localStorage) {

    var factory = {};
    var message = {
        msgBadget: 0,
        lastopentime: 0,
    };

    // --------------------------------
    // 取得所有系統通知訊息以及最後讀取時間
    // --------------------------------
    var getAllMsgs = function() {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/MessageAction.do",
            method: "GET",
            params: {
                op: "getAllMsgs"
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }            
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : MessageService.getAllMsgs request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    var updateLastopentime = function(lastopentime) {

        factory.message.msgBadget = 0;
        factory.message.lastopentime = lastopentime;

        $localStorage.message.lastopentime = lastopentime;
    }

    var setMsgBadget = function(msgBadget) {

        factory.isOrderTabShowTip = msgBadget > factory.message.msgBadget;
        factory.message.msgBadget = msgBadget;
    }

    var setOrderTabShowTip = function(isOrderTabShowTip) {

        factory.isOrderTabShowTip = isOrderTabShowTip;
    }

    /*==========================
        Members
    ==========================*/
    factory.message = message;
    factory.isOrderTabShowTip = false;

    /*==========================
        Methods
    ==========================*/
    factory.getAllMsgs = getAllMsgs; // 取得所有系統通知訊息以及最後讀取時間
    factory.updateLastopentime = updateLastopentime;
    factory.setMsgBadget = setMsgBadget;
    factory.setOrderTabShowTip = setOrderTabShowTip;

    return factory;
}]);